<template>
  <div class='lt-scene-eating'>
    <transition name='lt-t-eating'>
      <img
        src="../../assets/eatout-1.svg"
        class="lt-scene-eatout_1"
        alt=""
        v-show="eatout === 1"
      />
    </transition>

    <transition name='lt-t-eating'>
      <img
        src="../../assets/eatout-2.svg"
        class="lt-scene-eatout_2"
        alt=""
        v-show="eatout === 2"
      />
    </transition>

    <transition name='lt-t-eating'>
      <img
        src="../../assets/eatout-3.svg"
        class="lt-scene-eatout_3"
        alt=""
        v-show="eatout === 3"
      />
    </transition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'scene.status.eatout',
    ]),
  },
};
</script>

<style lang='scss'>
$img-base: '../../assets';

$img-width: 434;
$img-height: 266;

.lt-scene-eating {
  position: absolute;
  top: proportionSize(135, $scene-height);
  left: proportionSize(216, $scene-width);
  width: proportionSize(434, $scene-width);
  height: proportionSize(266, $scene-height);

  background: transparent url("#{$img-base}/eatout-bg.svg") no-repeat center center;
  background-size: cover;
  overflow: hidden;
}

.lt-scene-eatout_1,
.lt-scene-eatout_2,
.lt-scene-eatout_3 {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.lt-scene-eatout_1 {
  height: proportionSize(197, $img-height);
}

.lt-scene-eatout_2 {
  height: proportionSize(229, $img-height);
}

.lt-scene-eatout_3 {
  height: proportionSize(202, $img-height);
}


.lt-t-eating-enter-active {
  transition: transform .3s linear .3s, opacity .3s linear .3s;
}

.lt-t-eating-leave-active {
  transition: transform .3s linear, opacity .3s linear;
}

.lt-t-eating-enter {
  transform: translateX(-100%);
  opacity: 0;
}

.lt-t-eating-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

</style>
